import i18next from "i18next";
import * as yup from "yup";

export function validation() {
  const URL =
    /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi;

  return yup.object().shape({
    name: yup
      .string()
      .required(i18next.t("validation.createMemories.fullName"))
      .min(2, "Minimum 2 Character required")
      .trim(i18next.t("validation.common.noSpace")),
    relation: yup
      .string()
      // .required("relation is required")
      .min(2, "Minimum 2 Character required")
      .trim(i18next.t("validation.common.noSpace")),
    // dateOfBirth: yup.string().nullable().required("Birth Date is required"),
    // gender: yup
    //   .string()
    //   .required(i18next.t("validation.createMemories.gender")),
    profileLink: yup
      .string()
      .matches(URL, i18next.t("validation.createMemories.validUrl")),
  });
}
